export default "__VITE_ASSET__DHLY_bYH__"